import { Value } from '../types/GenericFormTypes';

export const getFieldValue = (values: Value[], fieldId: string) =>
  values?.find((v) => v.id === fieldId);
